<template>
  <RootModalComponent
    :name="$MODAL_NAME.ALIVE"
    icon="ri-coupon-3-line"
    width="400"
    :footer="modalFooter"
    :mobile-type="$MODAL_TYPE_MOBILE.BUBBLE"
    :frame="false"
    @cancel="onCancel"
    @beforeOpen="beforeOpen"
  >
    <div class="alive-modal">
      <div class="alive-modal__inner">
        <div class="alive-modal__title">
          {{ 'alive_modal_title' | translate }}
        </div>
        <div class="alive-modal__timer">
          {{ aliveModalTimer }}
        </div>
      </div>
    </div>
  </RootModalComponent>
</template>

<script>

import RootModalComponent from './RootModalComponent'
import Dropdown from '../controls/Dropdown'
import CheckboxList from '../controls/CheckboxList'
import * as moment from "moment";

export default {
  components: {
    RootModalComponent,
    Dropdown,
    CheckboxList
  },
  data() {
    return {
      currentTags: [],
      tags: [],
      timerUnsubscription: null,
      aliveModalTimer: '00:00',
      modalFooter: {
        lineTop: false,
        items: [
          {
            type: 'primary',
            action: 'cancel',
            title: 'alive_modal_button'
          }
        ]
      }
    }
  },
  computed: {
    service() {
      return this.$ticketService.getCurrentService(this.$store.currentTicket.office_service_id)
    }
  },
  methods: {
    beforeOpen() {
      const eventTime = moment().add(2, 'minutes');
      // const eventTime = moment().add(10, 'seconds');
      this.timerUnsubscription = this.$eventEmitter.subscribe(this.$eventEmitter.eventTypes.TIME_TICK, () => {
        const seconds = eventTime.diff(moment(), 'seconds');

        this.aliveModalTimer = moment().startOf('day')
          .seconds(seconds)
          .format('mm:ss');

        if (seconds <= 0) {
          this.clearTimer();
          this.$authService.logout();
        }
      })
    },
    clearTimer() {
      if (this.timerUnsubscription) {
        this.timerUnsubscription();
      }
    },
    onCancel() {
      this.clearTimer();
      this.$ticketService.startTicketTimer(this.service.time_limit * 60);
      this.$modal.hide(this.$MODAL_NAME.ALIVE)
    }
  }
}
</script>

<style lang="scss" scoped>

  .alive-modal {
    &__inner {
      padding: 32px 16px 16px 16px;
      text-align: center;
    }
    &__icon {
      height: 48px;
      font-size: 48px;
      vertical-align: middle;
      margin-bottom: 40px;
    }
    &__title {
      color: var(--label-secondary);
      font-weight: 500;
      font-size: 16px;
      line-height: 150%;
      margin-bottom: 8px;
    }
    &__timer {
      font-size: 42px;
      font-weight: 300;
      color: var(--accent-pink);
      line-height: 51px;
    }
  }

  @media (max-width: 425px) {
  }
</style>
